
export default function(image){
  let chars = image.substring(0,2);
  if(chars=="aw"){
    return "Adam Whitlock"
  }else if(chars=="ad"){
    return "Andrew Desforges"
  }else if(chars=="ag"){
    return "Austin Griffith"
  }else if(chars=="wg"){
    return "wgmeets"
  }else if(chars=="ts"){
    return "thestarflyer"
  }else if(chars=="jb"){
    return "jbdoge"
  }else if(chars=="pz"){
    return "PersonZ"
  }else if(chars=="ce"){
    return "Max Brody"
  }else if(chars=="vp"){
    return "Valerio Poltrini"
  }else if(chars=="al"){
    return "Arya Love"
  }else if(chars=="mt"){
    return "Mtimetraveller"
  }else if(chars=="tb"){
    return "th3build"
  }else if(chars=="tu"){
    return "TechUnboxin"
  }else if(chars=="js"){
    return "jeff"
  }else if(chars=="cs"){
    return "The CryptoStache"
  }else if(chars=="se"){
    return "SunnyEgo"
  }else if(chars=="sp"){
    return "Seth"
  }



  return "Unknown"
}



// WEBPACK FOOTER //
// ./src/modules/artist.js